export * from './delete-projekt-art.component';
export * from './delete-projekt-art.component.module';